{
  "familyId": "GET-GROOT-VERGELIJK",
  "questions": [
    {
      "id": "GET-GROOT-VERGELIJK-001",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een leraar schrijft vier getallen op het bord: 567, 576, 657, 675. Een leerling zegt: \"657 is het grootst, want het begint met het hoogste cijfer.\" Wat klopt er niet aan deze redenering?",
      "context": null,
      "options": [
        "675 is groter, want bij gelijke honderdtallen vergelijk je de tientallen: 7  5",
        "De leerling heeft gelijk — 657 is het grootst",
        "576 is het grootst, want 7 + 6 = 13 is de hoogste som",
        "Alle getallen met een 6 vooraan zijn even groot"
      ],
      "correctAnswer": 0,
      "conceptId": "compare_three_digit",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "group": 6,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.vergelijk-honderdtallen-genoeg", "label": "Stopt bij honderdtallen — vergelijkt niet door bij gelijke posities", "optionIndex": 1 },
          { "id": "get.vergelijk-cijfers-optellen", "label": "Telt cijfers op i.p.v. positie voor positie vergelijken", "optionIndex": 2 },
          { "id": "get.gelijke-cijfers-gelijke-getallen", "label": "Denkt dat getallen met dezelfde cijfers gelijk zijn", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Getallen vergelijken", "content": "Vergelijk cijfer voor cijfer van links naar rechts: honderdtallen eerst, dan tientallen, dan eenheden. Bij gelijke honderdtallen vergelijk je de tientallen.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De leerling vergelijkt alleen de honderdtallen (6 > 5), maar vergeet de tientallen te vergelijken. Zowel 657 als 675 beginnen met 6. Vergelijk de tientallen: 5 vs 7. Omdat 7 > 5, is 675 > 657. De leerling had dus ongelijk.",
        "solutionSteps": [
          "Honderdtallen vergelijken: 5, 5, 6, 6 → 657 en 675 zijn kandidaten",
          "De leerling stopt hier — dat is de fout",
          "Vergelijk de tientallen: 657 heeft 5, 675 heeft 7",
          "7 > 5, dus 675 > 657 → 675 is het grootst"
        ],
        "distractorExplanations": {
          "0": "Goed! De leerling vergat de tientallen te vergelijken. Bij gelijke honderdtallen (beide 6) vergelijk je de tientallen: 7 > 5, dus 675 > 657.",
          "1": "Je dacht waarschijnlijk dat de leerling gelijk heeft. Maar 657 en 675 hebben allebei honderdtal 6. Je moet dan de tientallen vergelijken: 5 < 7, dus 675 is groter. Onthoud: vergelijk altijd door tot je een verschil vindt.",
          "2": "Je dacht waarschijnlijk dat je de cijfers moet optellen. Maar bij getallen vergelijken tel je niet op — je vergelijkt positie voor positie van links naar rechts. Onthoud: honderdtallen eerst, dan tientallen, dan eenheden.",
          "3": "Je dacht waarschijnlijk dat getallen met dezelfde honderdtallen gelijk zijn. Maar 657 ≠ 675 — de tientallen zijn verschillend (5 vs 7). Onthoud: vergelijk alle posities."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-002",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "In een webshop staan 4 versies van hetzelfde sportshirt voor €234, €243, €324 en €342. Je wilt de goedkoopste kopen. Een vriend zegt: \"€243 is het goedkoopst.\" Klopt dat?",
      "context": null,
      "options": [
        "Nee, €234 is goedkoper — bij gelijke honderdtallen is tientalcijfer 3 < 4",
        "Ja, €243 is het goedkoopst",
        "Nee, €324 is goedkoper want het heeft de meeste honderdtallen",
        "Nee, alle bedragen met een 2 vooraan kosten evenveel"
      ],
      "correctAnswer": 0,
      "conceptId": "compare_smallest",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.66,
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kleinste getal vinden", "content": "Vergelijk de honderdtallen eerst. Het kleinste honderdtal geeft het kleinste getal. Bij gelijke honderdtallen vergelijk je de tientallen.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De collega vergelijkt de honderdtallen correct (2 < 3), maar vergeet de tientallen. Zowel €234 als €243 hebben honderdtal 2. Vergelijk de tientallen: 3 vs 4. Omdat 3 < 4, is €234 < €243. De korting gaat naar €234.",
        "solutionSteps": [
          "Honderdtallen: 2, 2, 3, 3 → €234 en €243 zijn kandidaten",
          "Vergelijk de tientallen: 234 heeft 3, 243 heeft 4",
          "3 < 4, dus €234 < €243",
          "€234 is het goedkoopst — daar gaat de korting naartoe"
        ],
        "distractorExplanations": {
          "0": "Goed! €234 is goedkoper dan €243. Bij gelijke honderdtallen vergelijk je de tientallen: 3 < 4.",
          "1": "Je dacht waarschijnlijk dat de vriend gelijk heeft. Maar €234 en €243 hebben allebei honderdtal 2. Vergelijk de tientallen: 3 < 4, dus €234 is kleiner. Onthoud: vergelijk door tot je een verschil vindt.",
          "2": "Je dacht waarschijnlijk dat meer honderdtallen goedkoper is. Maar honderdtal 3 > 2, dus €324 is juist duurder. Onthoud: een groter honderdtal = een groter getal.",
          "3": "Je dacht waarschijnlijk dat getallen met dezelfde honderdtallen gelijk zijn. Maar €234 ≠ €243 — de tientallen zijn verschillend. Onthoud: vergelijk alle posities."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-003",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "In de dierentuin schrijft een verzorger de gewichten op van vier dieren: 89 kg, 98 kg, 809 kg en 890 kg. Hij wil ze sorteren van licht naar zwaar. Een stagiair zegt: \"809 moet vóór 98, want 8 < 9.\" Waarom klopt dat niet?",
      "context": null,
      "options": [
        "809 is een 3-cijferig getal en altijd groter dan het 2-cijferige 98",
        "De collega heeft gelijk — 809 < 98",
        "Je moet de getallen optellen om te vergelijken",
        "809 en 98 zijn even groot omdat ze allebei een 8 en een 9 bevatten"
      ],
      "correctAnswer": 0,
      "conceptId": "order_mixed_digits",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Getallen ordenen", "content": "Meer cijfers = groter getal. 3-cijferige getallen zijn altijd groter dan 2-cijferige getallen. 809 > 98.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De collega vergelijkt het eerste cijfer (8 < 9), maar vergeet dat het aantal cijfers belangrijker is. Een 3-cijferig getal (809) is altijd groter dan een 2-cijferig getal (98). Het maakt niet uit dat 8 < 9 — 809 heeft honderdtallen, en 98 niet.",
        "solutionSteps": [
          "Tel het aantal cijfers: 98 (2 cijfers) en 809 (3 cijfers)",
          "3-cijferig > 2-cijferig, altijd",
          "Dus 809 > 98 — de collega heeft ongelijk",
          "Juiste volgorde: 89, 98, 809, 890"
        ],
        "distractorExplanations": {
          "0": "Goed! Een 3-cijferig getal is altijd groter dan een 2-cijferig getal. 809 > 98, ongeacht de eerste cijfers.",
          "1": "Je dacht waarschijnlijk dat de stagiair gelijk heeft. Maar 809 is een 3-cijferig getal (honderdtallen!) en 98 is een 2-cijferig getal. 809 > 98. Onthoud: meer cijfers = groter getal.",
          "2": "Je dacht waarschijnlijk dat je getallen moet optellen om te vergelijken. Maar je vergelijkt getallen door het aantal cijfers te tellen en dan positie voor positie te vergelijken. Onthoud: vergelijken ≠ optellen.",
          "3": "Je dacht waarschijnlijk dat dezelfde cijfers gelijke getallen opleveren. Maar de positie van de cijfers bepaalt de waarde: 809 = 800 + 9, terwijl 98 = 90 + 8. Onthoud: de positie van een cijfer bepaalt zijn waarde."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-004",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een sportcoach vergelijkt scores van twee teams: Team A heeft 1.234 punten, Team B heeft 1.243 punten. Op welke positie verschilt het eerste cijfer?",
      "context": null,
      "options": [
        "De tientallen: 3 bij Team A en 4 bij Team B",
        "De honderdtallen: 2 bij Team A en 2 bij Team B",
        "De eenheden: 4 bij Team A en 3 bij Team B",
        "De duizendtallen: 1 bij Team A en 1 bij Team B"
      ],
      "correctAnswer": 0,
      "conceptId": "compare_symbols",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Positie voor positie vergelijken", "content": "Vergelijk van links naar rechts: duizendtallen (1=1), honderdtallen (2=2), tientallen (3≠4). Het eerste verschil zit bij de tientallen.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "Vergelijk van links naar rechts: duizendtallen 1 = 1 (gelijk), honderdtallen 2 = 2 (gelijk), tientallen 3 ≠ 4 (hier zit het verschil!). Team B heeft tientalcijfer 4 > 3, dus Team B wint.",
        "solutionSteps": [
          "Duizendtallen: 1 = 1 → gelijk",
          "Honderdtallen: 2 = 2 → gelijk",
          "Tientallen: 3 ≠ 4 → hier zit het verschil",
          "Team B (1.243) > Team A (1.234) want 4 > 3"
        ],
        "distractorExplanations": {
          "0": "Goed! Het eerste verschil zit bij de tientallen: Team A heeft 3, Team B heeft 4. Daarom wint Team B.",
          "1": "Je dacht waarschijnlijk dat het verschil bij de honderdtallen zit. Maar beide teams hebben honderdtal 2 — die zijn gelijk. Het verschil zit bij de tientallen (3 vs 4). Onthoud: vergelijk van links naar rechts tot je een verschil vindt.",
          "2": "Je dacht waarschijnlijk dat het verschil bij de eenheden zit. De eenheden zijn inderdaad verschillend (4 vs 3), maar het eerste verschil zit al bij de tientallen. Onthoud: vergelijk van links naar rechts — de eerste positie met een verschil is het belangrijkst.",
          "3": "Je dacht waarschijnlijk dat het verschil bij de duizendtallen zit. Maar beide teams hebben duizendtal 1 — die zijn gelijk. Onthoud: als de duizendtallen gelijk zijn, vergelijk je de honderdtallen, dan de tientallen."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-005",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een postbode moet een pakket bezorgen op het adres dat het dichtst bij nummer 500 ligt. De huisnummers zijn: 498, 510, 480, 520. Ze berekent de afstanden. Welk huisnummer is het dichtst bij?",
      "context": null,
      "options": ["498 — verschil is 2", "510 — verschil is 10", "480 — verschil is 20", "520 — verschil is 20"],
      "correctAnswer": 0,
      "conceptId": "compare_closest_to",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.69,
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dichtst bij een getal", "content": "Bereken het verschil met 500 voor elk getal. Het getal met het kleinste verschil ligt het dichtst bij. 498: verschil = 2. 510: verschil = 10. 480: verschil = 20. 520: verschil = 20.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De postbode berekent het verschil met 500 voor elk huisnummer: 500 − 498 = 2, 510 − 500 = 10, 500 − 480 = 20, 520 − 500 = 20. Het kleinste verschil is 2, dus huisnummer 498 ligt het dichtst bij 500.",
        "solutionSteps": [
          "Bereken elk verschil met 500:",
          "498: 500 − 498 = 2",
          "510: 510 − 500 = 10",
          "480: 500 − 480 = 20, 520: 520 − 500 = 20",
          "Kleinste verschil = 2 → antwoord: 498"
        ],
        "distractorExplanations": {
          "0": "Goed! 498 ligt maar 2 van 500 af — het kleinste verschil van alle opties.",
          "1": "Je dacht waarschijnlijk dat 510 het dichtst bij is. Maar 510 − 500 = 10, en 500 − 498 = 2. Omdat 2 < 10, is 498 dichterbij. Onthoud: bereken het verschil voor elk getal.",
          "2": "Je dacht waarschijnlijk dat 480 het dichtst bij is. Maar 500 − 480 = 20, en 500 − 498 = 2. Omdat 2 < 20, is 498 dichterbij. Onthoud: het maakt niet uit of een getal boven of onder 500 ligt — het verschil telt.",
          "3": "Je dacht waarschijnlijk dat 520 het dichtst bij is. Maar 520 − 500 = 20, en 500 − 498 = 2. Omdat 2 < 20, is 498 dichterbij. Onthoud: bereken het verschil."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-006",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "ordering",
      "question": "Een postbode sorteert huisnummers. Zet deze getallen van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["742", "427", "274", "724"],
        "correctOrder": [2, 1, 3, 0]
      },
      "group": 6,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getallen ordenen",
            "content": "Vergelijk cijfer voor cijfer van links naar rechts: honderdtallen eerst, dan tientallen, dan eenheden. Het kleinste honderdtal komt eerst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "order_three_digit",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Vergelijk de honderdtallen: 7, 4, 2, 7. Het kleinste honderdtal is 2 → 274 eerst. Dan honderdtal 4 → 427. Dan twee getallen met honderdtal 7: vergelijk tientallen 4 vs 2 → 724 < 742. Volgorde: 274, 427, 724, 742.",
        "solutionSteps": [
          "Vergelijk honderdtallen: 2, 4, 7, 7",
          "274 (honderdtal 2) is het kleinst",
          "427 (honderdtal 4) is de tweede",
          "724 vs 742: tientalcijfer 2 < 4 → 724 < 742",
          "Volgorde: 274, 427, 724, 742"
        ]
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-007",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "ordering",
      "question": "Een bibliothecaris sorteert boeken op nummer. Zet deze getallen van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["3.456", "3.465", "3.546", "3.654"],
        "correctOrder": [0, 1, 2, 3]
      },
      "group": 6,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grote getallen ordenen",
            "content": "Bij getallen met hetzelfde aantal cijfers: vergelijk van links naar rechts. Duizendtallen eerst, dan honderdtallen, dan tientallen, dan eenheden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "order_four_digit",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Alle getallen beginnen met 3 (duizendtallen gelijk). Vergelijk de honderdtallen: 4, 4, 5, 6. De getallen met honderdtal 4 (3.456 en 3.465) komen eerst. Vergelijk hun tientallen: 5 < 6 → 3.456 < 3.465. Dan 3.546, dan 3.654.",
        "solutionSteps": [
          "Duizendtallen: alle 3 → gelijk",
          "Honderdtallen: 4, 4, 5, 6",
          "3.456 vs 3.465: tientallen 5 < 6 → 3.456 eerst",
          "Volgorde: 3.456, 3.465, 3.546, 3.654"
        ]
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-008",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "ordering",
      "question": "Een sportkampioenschap heeft eindscores voor vier deelnemers: 1.200, 980, 85 en 1.020 punten. Zet ze van laag naar hoog.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["1.200", "980", "85", "1.020"],
        "correctOrder": [2, 1, 3, 0]
      },
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getallen met verschillend aantal cijfers",
            "content": "Meer cijfers = groter getal. 2-cijferige getallen zijn altijd kleiner dan 3-cijferige, en 3-cijferige zijn kleiner dan 4-cijferige.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "order_mixed_digits_interactive",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Groepeer op aantal cijfers: 85 (2-cijferig), 980 (3-cijferig), 1.020 en 1.200 (4-cijferig). 2-cijferig < 3-cijferig < 4-cijferig. Van de 4-cijferige: 1.020 < 1.200. Volgorde: 85, 980, 1.020, 1.200.",
        "solutionSteps": [
          "Groepeer: 85 (2-cijferig), 980 (3-cijferig), 1.020 en 1.200 (4-cijferig)",
          "Minder cijfers = kleiner getal",
          "85 < 980 < 1.020 < 1.200",
          "Check 4-cijferig: 1.020 < 1.200 (honderdtal 0 < 2) ✓"
        ]
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-009",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "number_sequence",
      "question": "Een postbode sorteert pakketten op huisnummer. Vul de ontbrekende huisnummers in de reeks aan.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sequence": ["150", "?", "350", "450", "?"],
        "missingIndex": 1,
        "correctValue": "250",
        "correctValues": ["250", "550"],
        "rule": "+100"
      },
      "group": 6,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "numberLineLeaps",
          "data": {
            "start": 350,
            "leaps": [
              { "size": 100, "label": "+ 100" },
              { "size": 100, "label": "+ 100" }
            ],
            "hideEndValue": true,
            "label": "De stap is +100 — gebruik dat patroon ook voor het gat eerder in de reeks",
            "mode": "stimulus"
          },
          "a11y": { "alt": "Getallenlijn met twee sprongen van +100 vanaf 350; de laatste landing is verborgen — geen van de ontbrekende reekswaarden wordt op de lijn getoond" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getallenreeks aanvullen",
            "content": "Zoek het patroon: wat is het verschil tussen opeenvolgende getallen? 350 − 150 = 200, maar er zit een gat. 450 − 350 = 100. Het patroon is steeds +100. Dus: 150, 250, 350, 450, 550.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "compare_number_sequence",
      "variantIndex": 9,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het patroon is steeds +100. Tussen 350 en 450 zit een verschil van 100. Dus: 150 + 100 = 250 (eerste ontbrekende getal), en 450 + 100 = 550 (tweede ontbrekende getal). De reeks is: 150, 250, 350, 450, 550.",
        "solutionSteps": [
          "Zoek het verschil: 450 − 350 = 100",
          "Patroon: steeds +100",
          "Eerste gat: 150 + 100 = 250",
          "Tweede gat: 450 + 100 = 550",
          "Reeks: 150, 250, 350, 450, 550"
        ]
      }
    }
  ]
}